import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import AppSidebar from './components/Layout/AppSidebar';
import AppHeader from './components/Layout/AppHeader';
import Dashboard from './pages/Dashboard';
import StationManagement from './pages/StationManagement';
import HistoricalDataManagement from './pages/HistoricalDataManagement';
import WeatherDataManagement from './pages/WeatherDataManagement';
import WeatherPrediction from './pages/WeatherPrediction';
import ModelManagement from './pages/ModelManagement';
import PowerPrediction from './pages/PowerPrediction';
import PredictionOutputConfig from './pages/PredictionOutputConfig';
import PredictionEvaluation from './pages/PredictionEvaluation';
import LoginPage from './components/LoginPage';
import LandingPage from './components/LandingPage';
import { UserProvider, useUser } from './contexts/UserContext';
import './App.css';

const { Content, Sider } = Layout;

// 主应用内容组件
const AppContent: React.FC = () => {
  const { user, sidebarCollapsed } = useUser();

  // 如果用户未登录，显示首页
  if (!user) {
    return <LandingPage />;
  }

  const sidebarWidth = sidebarCollapsed ? 80 : 250;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        width={250}
        collapsedWidth={80}
        collapsed={sidebarCollapsed}
        className="app-sidebar"
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          transition: 'all 0.2s',
        }}
      >
        <AppSidebar />
      </Sider>

      <Layout style={{
        marginLeft: sidebarWidth,
        transition: 'margin-left 0.2s'
      }}>
        <AppHeader />
        <Content style={{
          margin: '16px',
          background: '#f0f2f5',
          minHeight: 'calc(100vh - 64px - 32px)'
        }}>
          <div style={{
            padding: '24px',
            background: '#fff',
            minHeight: '100%',
            borderRadius: '6px'
          }}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/stations" element={<StationManagement />} />
              <Route path="/historical-data" element={<HistoricalDataManagement />} />
              <Route path="/weather-data" element={<WeatherDataManagement />} />
              <Route path="/weather-prediction" element={<WeatherPrediction />} />
              <Route path="/models" element={<ModelManagement />} />
              <Route path="/prediction" element={<PowerPrediction />} />
              <Route path="/output-config" element={<PredictionOutputConfig />} />
              <Route path="/prediction-evaluation" element={<PredictionEvaluation />} />
            </Routes>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

const App: React.FC = () => {
  return (
    <UserProvider>
      <Router>
        <AppContent />
      </Router>
    </UserProvider>
  );
};

export default App;
